import { render, staticRenderFns } from "./Papelera.vue?vue&type=template&id=60bbaf6a&"
import script from "./Papelera.vue?vue&type=script&lang=js&"
export * from "./Papelera.vue?vue&type=script&lang=js&"
import style0 from "./Papelera.vue?vue&type=style&index=0&id=60bbaf6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports